// tslint:disable
import 'jquery';
import * as Cookie from 'js-cookie';
import { get } from 'lodash';
import * as React from 'react';
import { ContentBuilderField } from '../../components/fields/contentBuilder.field';
import { InputField } from '../../components/fields/input.field';
import { MediaItemField } from '../../components/fields/media-item.field';
import { SeoMetadataField } from '../../components/fields/seoMetadata.field';
import { TimestampBlameable } from '../../components/fields/TimestampBlameable';
import { FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { Validators } from '../../components/libs/Validators';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';

export class DefaultPage extends React.Component<any, any> {
    public state: any = {
        site: {},
        sites: [],
        user: {}
    };
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    componentDidMount() {
        try {
            this.setState({
                site: JSON.parse(Cookie.get('site') as string),
                sites: JSON.parse(Cookie.get('sites') as string),
                user: JSON.parse(Cookie.get('user') as string)
            });
        } catch (err) {
            window.location.href = '/login';
        }
    }

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    render() {
        return (
            <ResourceLoader
                entity="page"
                entityId={this.props.ENTITY_ID}
                forceQuery={{limit: 50}}
                render={(form: FormLib) => <div>
                    <div id="page-title">
                        <h2>
                            {this.props.IS_CREATE ? 'Create new page' : 'Edit page'}
                        </h2>
                        {get(form.fields.slug, 'value') &&
                        <p><a
                            href={`http://www.${get(this.state.site, 'domain')}/${get(form.fields.slug, 'value')}`}
                            target="_blank">http://www.{get(this.state.site, 'domain')}/{get(form.fields.slug, 'value')}</a>
                        </p>
                        }
                    </div>
                    <LoaderComponent isLoading$={this.executor.loading$}/>

                    <div className="row">
                        <div className="col-xs-12 col-md-9">
                            <ToggleBoxComponent title="Page details" color="green" alwaysOpen={true}>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <InputField
                                            field={form.fields.title}
                                            validators={[
                                                Validators.required('Required')
                                            ]}/>

                                        <InputField
                                            field={form.fields.slug}
                                            validators={[Validators.required('Required')]}/>

                                        <ContentBuilderField
                                            field={form.fields.content}
                                            height={800}
                                            // validators={[Validators.wysiwygRequired('required')]}
                                        />

                                        <button className="btn btn-primary pull-left"
                                                onClick={() => this.saveForm(form)}>Save
                                        </button>
                                    </div>
                                </div>
                            </ToggleBoxComponent>

                            <SeoMetadataField
                                field={form.fields.seoMetadata}
                            />

                        </div>
                        <div className="col-xs-12 col-md-3">
                            <ToggleBoxComponent title="Media" color="green" alwaysOpen={true}
                                                preIcon="fa-image">
                                <div className="row">
                                    <div className="col-xs-12">
                                        <MediaItemField
                                            field={form.fields.cover}
                                            validators={[
                                                Validators.required('Required')
                                            ]}
                                        />
                                    </div>
                                </div>
                            </ToggleBoxComponent>
                            <ToggleBoxComponent title="Other" alwaysOpen={true} preIcon="fa-eye">
                                <div className="row">
                                    <div className="col-xs-12">

                                        <TimestampBlameable form={form}/>
                                    </div>
                                </div>
                            </ToggleBoxComponent>
                        </div>
                    </div>
                </div>}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.page.tsx